(function () {
    class WhatsAppChatBySquadkin extends HTMLElement {
        constructor() {
            super();
            this.config = {};
            if (window.whatsappchatsk && window.whatsappchatsk.configurations) {
              try {
              const configurations = window.whatsappchatsk.configurations;
              this.config = configurations;
                } catch (error) {
                  console.error("Failed to parse configurations JSON:", error);
                }
              } else {
                console.error("Configurations are not available on window.whatsappchatsk");
              }
            
            this.render();
        }
  
        render() {
            this.attachShadow({ mode: 'open' });
            this.style.display = 'block';
            let now = new Date();
            let hour = now.getHours();
            let minute = now.getMinutes();
            let hourandminut = hour + ":" + minute;
            let WrapperContainer = this.getWrapperContainer();
            let wrapperElement = WrapperContainer.content.querySelector('.squadkin-wrapper-container');
  
            let whatsAppUrl = this.getWhatsAppUrl(this.config.phoneNumber, (this.config.activateDefaultMessage ? this.config.defaultMessage: false));
            let button = this.getButton(this.config.iconOption, whatsAppUrl, this.config.iconcolor, this.config.bgcolor, this.config.textcolor, this.config.selectedSize, this.config.logo_with_image, this.config.logo_with_text,
                this.config.iconModelPopup, this.config.iconModelPopupHeaderHeading, this.config.iconModelPopupHeaderResponseTime, this.config.iconModelPopupHeaderLogo, this.config.iconModelPopupChatText, hourandminut
            );
            wrapperElement.appendChild(button.content.cloneNode(true));
            
  
            this.shadowRoot.appendChild(WrapperContainer.content.cloneNode(true));
            this.shadowRoot.appendChild(this.getPlacementStyle(this.config.iconalignment, this.config.disancefromtop, this.config.disancefromleft, this.config.disancefromright, this.config.disancefrombottom));
            this.shadowRoot.appendChild(this.getSizeStyle(this.config.selectedSize, this.config.iconalignment));
            this.shadowRoot.appendChild(this.getVisibilityStyle(this.config.devicevisible));
            this.shadowRoot.appendChild(this.getCustomCSSStyle(this.config.customCss));
            let trackableLinks = this.shadowRoot.querySelectorAll('a');
              for (let i = 0; i < trackableLinks.length; i++) {
                  this.applyLinkTracking(this.config.enableGoodAnalyticsTracking,this.config.enableMetaPixelTracking,trackableLinks[i]);
              }
              document.addEventListener('DOMContentLoaded', (event) => {
                const whatsappButton = this.shadowRoot.querySelector('.squadkin-whatsapp-button');
                const whatsappSendButton = this.shadowRoot.querySelector('#send-it');
                const whatsappCloseButton = this.shadowRoot.querySelector('.close-chat');
                if (whatsappButton) {
                    const that = this;
                    whatsappButton.addEventListener('click', function (event) {
                        const chatElement = that.shadowRoot.getElementById('whatsapp-chat');
                        if (chatElement) {
                            event.preventDefault();
                            chatElement.classList.remove('hide');
                            chatElement.classList.add('show');
                        }
                    });
                }
                if (whatsappCloseButton) {
                    const that = this;
                    whatsappCloseButton.addEventListener('click', function (event) {
                        const chatElement = that.shadowRoot.getElementById('whatsapp-chat');
                        if (chatElement) {
                            event.preventDefault();
                            chatElement.classList.add('hide');
                            chatElement.classList.remove('show');
                        }
                    });
                }

                if(whatsappSendButton) {
                    const that = this;
                    whatsappSendButton.addEventListener('click', function (event) {
                        event.preventDefault();
                        const chatInputValue = that.shadowRoot.getElementById('chat-input')?.value;
                        var wpURL = that.getWhatsAppUrl(that.config.phoneNumber, chatInputValue);
                        window.open(wpURL.href);
                    });
                }
            });
        }
  
        applyLinkTracking(googleAnalytics,metaPixel,link) {
          if (googleAnalytics) {
            link.addEventListener('click', function () {
              if (typeof gtag === 'function') {
                gtag('event', 'gty_whatsapp_button_click');
              }
            });
          }
    
          if (metaPixel) {
            link.addEventListener('click', function () {
              if (typeof fbq === 'function') {
                fbq('trackCustom', 'gty_whatsapp_button_click');
              }
            });
          }
        }
  
        applyVariables(message) {
          const replacements = {
            "current_page_url": function () { return window.location.href; }
          }
    
          for (let [placeholder, replacement] of Object.entries(replacements)) {
            message = message.replace(new RegExp(`\\{\\{\\s*${placeholder.replace(/\s+/g, '\\s*')}\\s*\\}\\}`, 'g'), replacement);
          }
    
          return message
        }
  
        getWrapperContainer() {
            const WrapperContainer = document.createElement('template');
  
            WrapperContainer.innerHTML = `
            <style>
            .squadkin-wrapper-container {
                display: inline-flex;
                align-items: flex-start;
                z-index: 9999;
                position: fixed;
            }
            </style>
  
            <div class="squadkin-wrapper-container"></div>`;
  
            return WrapperContainer;
        }
  
        getButton(iconoptions, link, colors, bgcolors, textColorHas, size, agentImage = false, buttonText = false, iconModelPopup, iconModelPopupHeaderHeading, iconModelPopupHeaderResponseTime, iconModelPopupHeaderLogo, iconModelPopupChatText, hourandminut) {
          let button = document.createElement('template');
    
          if (iconoptions == "option1" && !buttonText) {
            return button;
          }
  
          const sizes = {
            "small": "35px",
            "medium": "40px",
            "large": "45px",
          };

          let popupmodelchat = `
          <div id='whatsapp-chat' class='hide'>
          <div class='whatsapp-chat-header ${iconModelPopupHeaderResponseTime ? '' : 'sk-time-blank'}'>
              <div class='whatsapp-chat-avatar'>
                  <img src='${iconModelPopupHeaderLogo}' alt="${iconModelPopupHeaderHeading} Logo" width="30" height="30" />
              </div>
              <p><span class="whatsapp-chat-name">${iconModelPopupHeaderHeading || 'Support'}</span><br><small>${iconModelPopupHeaderResponseTime || ''}</small></p>
          </div>
          
          <div class='start-chat'>
              <div pattern="https://elfsight.com/assets/chats/patterns/whatsapp.png" class="WhatsappChat__Component-sc-1wqac52-0 whatsapp-chat-body">
              <div class="WhatsappChat__MessageContainer-sc-1wqac52-1 dAbFpq">
                  <div style="opacity: 0;" class="WhatsappDots__Component-pks5bf-0 eJJEeC">
                  <div class="WhatsappDots__ComponentInner-pks5bf-1 hFENyl">
                      <div class="WhatsappDots__Dot-pks5bf-2 WhatsappDots__DotOne-pks5bf-3 ixsrax"></div>
                      <div class="WhatsappDots__Dot-pks5bf-2 WhatsappDots__DotTwo-pks5bf-4 dRvxoz"></div>
                      <div class="WhatsappDots__Dot-pks5bf-2 WhatsappDots__DotThree-pks5bf-5 kXBtNt"></div>
                  </div>
                  </div>
                  <div style="opacity: 1;" class="WhatsappChat__Message-sc-1wqac52-4 kAZgZq">
                  <div class="WhatsappChat__Author-sc-1wqac52-3 bMIBDo">${iconModelPopupHeaderHeading}</div>
                  <div class="WhatsappChat__Text-sc-1wqac52-2 iSpIQi">${iconModelPopupChatText}</div>
                  <div class="WhatsappChat__Time-sc-1wqac52-5 cqCDVm">${hourandminut}</div>
                  </div>
              </div>
              </div>
              <div class='blanter-msg'>
              <textarea id='chat-input' placeholder='Write a response' maxlength='120' row='1'>${this.applyVariables(this.config.defaultMessage)}</textarea>
              <a href="${link}" target="_blank" id='send-it'><svg viewBox="0 0 448 448"><path d="M.213 32L0 181.333 320 224 0 266.667.213 416 448 224z"/></svg></a>
              </div>
          </div>
          <div id='get-number'></div>
              <a class='close-chat ${iconModelPopupHeaderResponseTime ? '' : 'sk-time-blank'}' href='javascript:void(0);'>×</a>
          </div>
          `;

          let finalpopupmodelchat = '';
            if (iconModelPopup) {
            finalpopupmodelchat = popupmodelchat;
            }
            
    
          switch (iconoptions) {
            case "option1":
              button.innerHTML = `
              <style>
                .squadkin-whatsapp-button {
                  text-decoration: none;
                  border-radius: 23px;
                  height: 46px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  padding-left: 16px;
                  padding-right: 16px;
                }
                .squadkin-whatsapp-button:focus,
                .squadkin-whatsapp-button:active,
                .squadkin-whatsapp-button:hover{
                    background-color: transparent;
                }
    
                .squadkin-whatsapp-button-logo {
                  width: ${sizes[size]};
                  height: ${sizes[size]};
                  filter: drop-shadow(1px 2px 3px #000000ad);
                }
    
                #whatsapp-chat.show ~ .squadkin-whatsapp-button .squadkin-whatsapp-button-text {
                    display: none;
                }
                .squadkin-whatsapp-button-text {
                  position: relative;
                  color: ${textColorHas};
                  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
                  font-size: 11px;
                  margin-right: 11px;
                  max-width: 140px;
                  background: ${bgcolors};
                  padding: 5px 10px;
                  border-radius: 5px;
                  font-weight: 500;
                  letter-spacing: 0;
                  filter: drop-shadow(1px 2px 3px #000000ad);
                  animation: fadeIn 1s ease-in-out 3s forwards;
                  transform: scale(0);
                  opacity:0;
                  ${buttonText.length > 30 && `margin-bottom: 30px;`}
                }
                .squadkin-whatsapp-button-text:after {
                  content: '';
                  border-width: 0px 0 10px 10px;
                  border-color: transparent transparent transparent ${bgcolors};
                  top: 0;
                  right: -7px;
                  width: 0;
                  height: 0;
                  border-style: solid;
                  position:absolute;
                }  
                .squadkin-whatsapp-notification-badge {
                  margin-top: -4px;
                  margin-right: -4px;
                }
                @keyframes fadeIn {
                  0% {
                    opacity: 0;
                    transform: scale(0%);
                  }
                  100% {
                    opacity: 100%;
                    transform: scale(100%);
                  }
                }
              </style>
              <style>
                    #whatsapp-chat {
                        box-sizing: border-box !important;
                        outline: none !important;
                        position: fixed;
                        width: 200px;
                        border-radius: 10px;
                        box-shadow: 0 1px 15px rgba(32, 33, 36, 0.28);
                        bottom: 50px;
                        right: 10px;
                        overflow: hidden;
                        z-index: 99;
                        animation-name: showchat;
                        animation-duration: .1s;
                        transform: scale(1);
                    }

                    .whatsapp-chat-header.sk-time-blank {
                        padding: 5px 5px 15px;
                    }
                    
                    .whatsapp-chat-header {
                        background: #009688;
                        background: #095e54;
                        color: #fff;
                        padding: 5px;
                        
                        & h3 {
                        margin: 0 0 10px;
                        }
                        
                        & p {
                        font-size: 7px !important;
                        line-height: 1.7;
                        margin: 0;
                        }
                        
                        .whatsapp-chat-name {
                        font-size: 8px;
                        font-weight: 600;
                        padding-bottom: 0;
                        margin-bottom: 0;
                        line-height: 0.5;
                        }
                    }
                    
                    .whatsapp-chat-avatar {
                        position: relative;
                        display: block;
                    }
                    .whatsapp-chat-avatar::after {
                        content: "";
                        bottom: 0px;
                        right: 0px;
                        width: 8px;
                        height: 8px;
                        box-sizing: border-box;
                        background-color: #4ad504;
                        display: block;
                        position: relative;
                        z-index: 1;
                        border-radius: 50%;
                        border: 2px solid #095e54;
                        left: 18px;
                        top: 22px;
                    }
                        
                    .whatsapp-chat-avatar img {
                        border-radius: 100%;
                        width: 30px;
                        height: 30px;
                        float: left;
                        margin: 0 5px 0 0;
                        object-fit: contain;
                    }

                    .info-chat span {
                        display: block;
                    }
                    #get-label,
                    span.chat-label {
                        font-size: 12px;
                        color: #888;
                    }
                    #get-nama,
                    span.chat-nama {
                        margin: 5px 0 0;
                        font-size: 15px;
                        font-weight: 700;
                        color: #222;
                    }
                    #get-label,
                    #get-nama {
                        color: #fff;
                    }
                    span.my-number {
                        display: none;
                    }
                    /* .blanter-msg {
                        color: #444;
                        padding: 20px;
                        font-size: 12.5px;
                        text-align: center;
                        border-top: 1px solid #ddd;
                    } */
                    textarea#chat-input {
                        border: none;
                        font-family: "Arial", sans-serif;
                        width: 100%;
                        height: 10px;
                        outline: none;
                        resize: none;
                        padding: 8px;
                        font-size: 8px;
                    }
                    
                    a#send-it {
                        width: 30px;
                        font-weight: 700;
                        padding: 0px 0px 0px 12px;
                        background: #eee;
                        border-radius: 0px;
                        height: 26px;
                        
                        svg {
                        fill:#a6a6a6;
                        height: 12px;
                        width: 12px;
                        }
                    }
                    
                    .first-msg {
                        background: transparent;
                        padding: 30px;
                        text-align: center;
                        & span {
                        background: #e2e2e2;
                        color: #333;
                        font-size: 14.2px;
                        line-height: 1.7;
                        border-radius: 10px;
                        padding: 15px 20px;
                        display: inline-block;
                        }
                    }
                    
                    .start-chat .blanter-msg {
                        display: flex;
                    }
                    #get-number {
                        display: none;
                    }
                    a.close-chat.sk-time-blank {
                        top: 3px;
                    }
                    a.close-chat {
                        position: absolute;
                        top: 5px;
                        right: 10px;
                        color: #fff;
                        font-size: 20px;
                        text-decoration: none;
                    }
                    
                    @keyframes ZpjSY{
                        0% {
                        background-color: rgb(182, 181, 186);
                        }
                        15% {
                        background-color: rgb(17, 17, 17);
                        }
                        25% {
                        background-color: rgb(182, 181, 186);
                        }
                    }
                    
                    @keyframes hPhMsj {
                        15% {
                        background-color: rgb(182, 181, 186);
                        }
                        25% {
                        background-color: rgb(17, 17, 17);
                        }
                        35% {
                        background-color: rgb(182, 181, 186);
                        }
                    }
                    
                    @keyframes iUMejp {
                        25% {
                        background-color: rgb(182, 181, 186);
                        }
                        35% {
                        background-color: rgb(17, 17, 17);
                        }
                        45% {
                        background-color: rgb(182, 181, 186);
                        }
                    }
                    
                    
                    @keyframes showhide {
                        from {
                        transform: scale(0.5);
                        opacity: 0;
                        }
                    }
                    @keyframes showchat {
                        from {
                        transform: scale(0);
                        opacity: 0;
                        }
                    }
                    @media screen and (max-width: 372px) {
                        #whatsapp-chat {
                        width: 15rem;
                        font-size: 80%;
                        }
                    }
                    .hide {
                        display: none;
                        animation-name: showhide;
                        animation-duration: 0.5s;
                        transform: scale(1);
                        opacity: 1;
                    }
                    .show {
                        display: block;
                        animation-name: showhide;
                        animation-duration: 0.5s;
                        transform: scale(1);
                        opacity: 1;
                    }
                    
                    .whatsapp-message-container {
                        display: flex;
                        z-index: 1;
                    }
                    
                    .whatsapp-message {
                        padding: 7px 14px 6px;
                        background-color: rgb(255, 255, 255);
                        border-radius: 0px 8px 8px;
                        position: relative;
                        transition: all 0.3s ease 0s;
                        opacity: 0;
                        transform-origin: center top 0px;
                        z-index: 2;
                        box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
                        margin-top: 4px;
                        margin-left: -54px;
                        max-width: calc(100% - 66px);
                    }
                    
                    .whatsapp-chat-body {
                        padding: 20px 20px 20px 10px;
                        background-color: rgb(230, 221, 212);
                        position: relative;
                        &::before {
                        display: block;
                        position: absolute;
                        content: "";
                        left: 0px;
                        top: 0px;
                        height: 100%;
                        width: 100%;
                        z-index: 0;
                        opacity: 0.08;
                        background-image: url("https://elfsight.com/assets/chats/patterns/whatsapp.png");
                        // background-image: url(https://res.cloudinary.com/eventbree/image/upload/v1575782560/Widgets/whatsappbg_opt.jpg);
                        }
                    }
                    
                    .dAbFpq {
                        display: flex;
                        z-index: 1;
                    }
                    
                    .eJJEeC {
                        background-color: rgb(255, 255, 255);
                        width: 52.5px;
                        height: 32px;
                        border-radius: 16px;
                        display: flex;
                        -moz-box-pack: center;
                        justify-content: center;
                        -moz-box-align: center;
                        align-items: center;
                        margin-left: 10px;
                        opacity: 0;
                        transition: all 0.1s ease 0s;
                        z-index: 1;
                        box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
                    }
                    
                    .hFENyl {
                        position: relative;
                        display: flex;
                    }
                    
                    .ixsrax {
                        height: 5px;
                        width: 5px;
                        margin: 0px 2px;
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;
                        animation-duration: 1.2s;
                        animation-iteration-count: infinite;
                        animation-timing-function: linear;
                        top: 0px;
                        background-color: rgb(158, 157, 162);
                        animation-name: ZpjSY;
                    }
                    
                    .dRvxoz {
                    
                        height: 5px;
                        width: 5px;
                        margin: 0px 2px;
                        background-color: rgb(182, 181, 186);
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;
                        animation-duration: 1.2s;
                        animation-iteration-count: infinite;
                        animation-timing-function: linear;
                        top: 0px;
                        animation-name: hPhMsj;
                    }
                    
                    .kAZgZq {
                            padding: 2px 10px 2px;
                            background-color: rgb(255, 255, 255);
                            border-radius: 0px 8px 8px;
                            position: relative;
                            transition: all 0.3s ease 0s;
                            opacity: 0;
                            transform-origin: center top 0px;
                            z-index: 2;
                            box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
                            margin-top: 4px;
                            margin-left: -61px;
                            max-width: calc(100%);
                        &::before {
                        position: absolute;
                        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAmCAMAAADp2asXAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACQUExURUxpccPDw9ra2m9vbwAAAAAAADExMf///wAAABoaGk9PT7q6uqurqwsLCycnJz4+PtDQ0JycnIyMjPf3915eXvz8/E9PT/39/RMTE4CAgAAAAJqamv////////r6+u/v7yUlJeXl5f///5ycnOXl5XNzc/Hx8f///xUVFf///+zs7P///+bm5gAAAM7Ozv///2fVensAAAAvdFJOUwCow1cBCCnqAhNAnY0WIDW2f2/hSeo99g1lBYT87vDXG8/6d8oL4sgM5szrkgl660OiZwAAAHRJREFUKM/ty7cSggAABNFVUQFzwizmjPz/39k4YuFWtm55bw7eHR6ny63+alnswT3/rIDzUSC7CrAziPYCJCsB+gbVkgDtVIDh+DsE9OTBpCtAbSBAZSEQNgWIygJ0RgJMDWYNAdYbAeKtAHODlkHIv997AkLqIVOXVU84AAAAAElFTkSuQmCC");
                        background-position: 50% 50%;
                        background-repeat: no-repeat;
                        background-size: contain;
                        content: "";
                        top: 0px;
                        left: -12px;
                        width: 12px;
                        height: 19px;
                    }
                    }
                    
                    .bMIBDo {
                        font-size: 7px;
                        font-weight: 700;
                        line-height: 18px;
                        color: rgba(0, 0, 0, 0.4);
                    }
                    
                    .iSpIQi {
                        font-size: 8px;
                        line-height: 19px;
                        margin-top: 4px;
                        color: rgb(17, 17, 17);
                    }
                    
                    .iSpIQi {
                        font-size: 7px;
                        line-height: 6px;
                        margin-top: 0;
                        color: rgb(17, 17, 17);
                    }
                    
                    .cqCDVm {
                        text-align: right;
                        margin-top: 4px;
                        font-size: 6px;
                        line-height: 16px;
                        color: 
                        rgba(17, 17, 17, 0.5);
                        margin-right: -8px;
                        margin-bottom: -4px;
                    }
              </style>
              
              ${finalpopupmodelchat}
              <a href='${!iconModelPopup ? link :"javascript:void(0);"}' target=_blank class="squadkin-whatsapp-button">
                <div class="squadkin-whatsapp-button-text">${buttonText}</div>
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="${size}" height="${size}" class="squadkin-whatsapp-button-logo">
                    <circle cx="256" cy="256" r="256" fill=${bgcolors} />
                    <path d="M256 108c-88.37 0-160 64.47-160 144 0 46.46 24.64 87.79 63.31 114.73-3.15 22.18-12.78 46.22-38.64 63.78 24.59-1.28 72.96-10.45 101.44-42.34 11.08 2.37 22.56 3.83 33.89 3.83 88.37 0 160-64.47 160-144S344.37 108 256 108z" fill=${colors} />
                    <circle cx="192" cy="252" r="20" fill=${bgcolors} />
                    <circle cx="256" cy="252" r="20" fill=${bgcolors} />
                    <circle cx="320" cy="252" r="20" fill=${bgcolors} />
                </svg>
              </a>`;
              break;
            case "option2":
              button.innerHTML = `
              <style>
                .squadkin-whatsapp-button {
                  background-color: ${bgcolors};
                  text-decoration: none;
                  border-radius: 100%;
                  width: ${sizes[size]};
                  height: ${sizes[size]};
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  animation-name: waAnimation;
                  animation-duration: 1s;
                  animation-timing-function: ease-out;
                  animation-iteration-count: infinite;
                }
                .squadkin-whatsapp-button:focus,
                .squadkin-whatsapp-button:active,
                .squadkin-whatsapp-button:hover{
                    background-color: transparent;
                }
                .squadkin-whatsapp-button svg{
                  padding:3px;
                  width: 100%;
                  height: 100%;
                }
                @keyframes waAnimation {
                  0% {
                    box-shadow: 0 0 0 0 rgba(74, 175, 80, 0.5);
                  }
                  80% {
                    box-shadow: 0 0 0 14px rgba(74, 175, 80, 0);
                  }
                }
              </style>
              <style>
                    #whatsapp-chat {
                        box-sizing: border-box !important;
                        outline: none !important;
                        position: fixed;
                        width: 200px;
                        border-radius: 10px;
                        box-shadow: 0 1px 15px rgba(32, 33, 36, 0.28);
                        bottom: 50px;
                        right: 10px;
                        overflow: hidden;
                        z-index: 99;
                        animation-name: showchat;
                        animation-duration: .1s;
                        transform: scale(1);
                    }

                    .whatsapp-chat-header.sk-time-blank {
                        padding: 5px 5px 15px;
                    }
                    
                    .whatsapp-chat-header {
                        background: #009688;
                        background: #095e54;
                        color: #fff;
                        padding: 5px;
                        
                        & h3 {
                        margin: 0 0 10px;
                        }
                        
                        & p {
                        font-size: 7px !important;
                        line-height: 1.7;
                        margin: 0;
                        }
                        
                        .whatsapp-chat-name {
                        font-size: 8px;
                        font-weight: 600;
                        padding-bottom: 0;
                        margin-bottom: 0;
                        line-height: 0.5;
                        }
                    }
                    
                    .whatsapp-chat-avatar {
                        position: relative;
                        display: block;
                    }
                    .whatsapp-chat-avatar::after {
                            content: "";
                            bottom: 0px;
                            right: 0px;
                            width: 8px;
                            height: 8px;
                            box-sizing: border-box;
                            background-color: #4ad504;
                            display: block;
                            position: relative;
                            z-index: 1;
                            border-radius: 50%;
                            border: 2px solid #095e54;
                            left: 18px;
                            top: 22px;
                        }
                        
                    .whatsapp-chat-avatar img {
                            border-radius: 100%;
                            width: 30px;
                            float: left;
                            margin: 0 5px 0 0;
                            height: 30px;
                            object-fit: contain;                        
                    }
                    
                    .info-chat span {
                        display: block;
                    }
                    #get-label,
                    span.chat-label {
                        font-size: 12px;
                        color: #888;
                    }
                    #get-nama,
                    span.chat-nama {
                        margin: 5px 0 0;
                        font-size: 15px;
                        font-weight: 700;
                        color: #222;
                    }
                    #get-label,
                    #get-nama {
                        color: #fff;
                    }
                    span.my-number {
                        display: none;
                    }
                    /* .blanter-msg {
                        color: #444;
                        padding: 20px;
                        font-size: 12.5px;
                        text-align: center;
                        border-top: 1px solid #ddd;
                    } */
                    textarea#chat-input {
                        border: none;
                        font-family: "Arial", sans-serif;
                        width: 100%;
                        height: 10px;
                        outline: none;
                        resize: none;
                        padding: 8px;
                        font-size: 8px;
                    }
                    
                    a#send-it {
                        width: 30px;
                        font-weight: 700;
                        padding: 0px 0px 0px 12px;
                        background: #eee;
                        border-radius: 0px;
                        height: 26px;
                        
                        svg {
                        fill:#a6a6a6;
                        height: 12px;
                        width: 12px;
                        }
                    }
                    
                    .first-msg {
                        background: transparent;
                        padding: 30px;
                        text-align: center;
                        & span {
                        background: #e2e2e2;
                        color: #333;
                        font-size: 14.2px;
                        line-height: 1.7;
                        border-radius: 10px;
                        padding: 15px 20px;
                        display: inline-block;
                        }
                    }
                    
                    .start-chat .blanter-msg {
                        display: flex;
                    }
                    #get-number {
                        display: none;
                    }
                    a.close-chat.sk-time-blank {
                        top: 3px;
                    }
                    a.close-chat {
                        position: absolute;
                        top: 5px;
                        right: 10px;
                        color: #fff;
                        font-size: 20px;
                        text-decoration: none;
                    }
                    
                    @keyframes ZpjSY{
                        0% {
                        background-color: rgb(182, 181, 186);
                        }
                        15% {
                        background-color: rgb(17, 17, 17);
                        }
                        25% {
                        background-color: rgb(182, 181, 186);
                        }
                    }
                    
                    @keyframes hPhMsj {
                        15% {
                        background-color: rgb(182, 181, 186);
                        }
                        25% {
                        background-color: rgb(17, 17, 17);
                        }
                        35% {
                        background-color: rgb(182, 181, 186);
                        }
                    }
                    
                    @keyframes iUMejp {
                        25% {
                        background-color: rgb(182, 181, 186);
                        }
                        35% {
                        background-color: rgb(17, 17, 17);
                        }
                        45% {
                        background-color: rgb(182, 181, 186);
                        }
                    }
                    
                    
                    @keyframes showhide {
                        from {
                        transform: scale(0.5);
                        opacity: 0;
                        }
                    }
                    @keyframes showchat {
                        from {
                        transform: scale(0);
                        opacity: 0;
                        }
                    }
                    @media screen and (max-width: 372px) {
                        #whatsapp-chat {
                        width: 15rem;
                        font-size: 80%;
                        }
                    }
                    .hide {
                        display: none;
                        animation-name: showhide;
                        animation-duration: 0.5s;
                        transform: scale(1);
                        opacity: 1;
                    }
                    .show {
                        display: block;
                        animation-name: showhide;
                        animation-duration: 0.5s;
                        transform: scale(1);
                        opacity: 1;
                    }
                    
                    .whatsapp-message-container {
                        display: flex;
                        z-index: 1;
                    }
                    
                    .whatsapp-message {
                        padding: 7px 14px 6px;
                        background-color: rgb(255, 255, 255);
                        border-radius: 0px 8px 8px;
                        position: relative;
                        transition: all 0.3s ease 0s;
                        opacity: 0;
                        transform-origin: center top 0px;
                        z-index: 2;
                        box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
                        margin-top: 4px;
                        margin-left: -54px;
                        max-width: calc(100% - 66px);
                    }
                    
                    .whatsapp-chat-body {
                        padding: 20px 20px 20px 10px;
                        background-color: rgb(230, 221, 212);
                        position: relative;
                        &::before {
                        display: block;
                        position: absolute;
                        content: "";
                        left: 0px;
                        top: 0px;
                        height: 100%;
                        width: 100%;
                        z-index: 0;
                        opacity: 0.08;
                        background-image: url("https://elfsight.com/assets/chats/patterns/whatsapp.png");
                        // background-image: url(https://res.cloudinary.com/eventbree/image/upload/v1575782560/Widgets/whatsappbg_opt.jpg);
                        }
                    }
                    
                    .dAbFpq {
                        display: flex;
                        z-index: 1;
                    }
                    
                    .eJJEeC {
                        background-color: rgb(255, 255, 255);
                        width: 52.5px;
                        height: 32px;
                        border-radius: 16px;
                        display: flex;
                        -moz-box-pack: center;
                        justify-content: center;
                        -moz-box-align: center;
                        align-items: center;
                        margin-left: 10px;
                        opacity: 0;
                        transition: all 0.1s ease 0s;
                        z-index: 1;
                        box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
                    }
                    
                    .hFENyl {
                        position: relative;
                        display: flex;
                    }
                    
                    .ixsrax {
                        height: 5px;
                        width: 5px;
                        margin: 0px 2px;
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;
                        animation-duration: 1.2s;
                        animation-iteration-count: infinite;
                        animation-timing-function: linear;
                        top: 0px;
                        background-color: rgb(158, 157, 162);
                        animation-name: ZpjSY;
                    }
                    
                    .dRvxoz {
                    
                        height: 5px;
                        width: 5px;
                        margin: 0px 2px;
                        background-color: rgb(182, 181, 186);
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;
                        animation-duration: 1.2s;
                        animation-iteration-count: infinite;
                        animation-timing-function: linear;
                        top: 0px;
                        animation-name: hPhMsj;
                    }
                    
                    .kAZgZq {
                            padding: 2px 10px 2px;
                            background-color: rgb(255, 255, 255);
                            border-radius: 0px 8px 8px;
                            position: relative;
                            transition: all 0.3s ease 0s;
                            opacity: 0;
                            transform-origin: center top 0px;
                            z-index: 2;
                            box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
                            margin-top: 4px;
                            margin-left: -61px;
                            max-width: calc(100%);
                        &::before {
                        position: absolute;
                        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAmCAMAAADp2asXAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACQUExURUxpccPDw9ra2m9vbwAAAAAAADExMf///wAAABoaGk9PT7q6uqurqwsLCycnJz4+PtDQ0JycnIyMjPf3915eXvz8/E9PT/39/RMTE4CAgAAAAJqamv////////r6+u/v7yUlJeXl5f///5ycnOXl5XNzc/Hx8f///xUVFf///+zs7P///+bm5gAAAM7Ozv///2fVensAAAAvdFJOUwCow1cBCCnqAhNAnY0WIDW2f2/hSeo99g1lBYT87vDXG8/6d8oL4sgM5szrkgl660OiZwAAAHRJREFUKM/ty7cSggAABNFVUQFzwizmjPz/39k4YuFWtm55bw7eHR6ny63+alnswT3/rIDzUSC7CrAziPYCJCsB+gbVkgDtVIDh+DsE9OTBpCtAbSBAZSEQNgWIygJ0RgJMDWYNAdYbAeKtAHODlkHIv997AkLqIVOXVU84AAAAAElFTkSuQmCC");
                        background-position: 50% 50%;
                        background-repeat: no-repeat;
                        background-size: contain;
                        content: "";
                        top: 0px;
                        left: -12px;
                        width: 12px;
                        height: 19px;
                    }
                    }
                    
                    .bMIBDo {
                        font-size: 7px;
                        font-weight: 700;
                        line-height: 18px;
                        color: rgba(0, 0, 0, 0.4);
                    }
                    
                    .iSpIQi {
                        font-size: 8px;
                        line-height: 19px;
                        margin-top: 4px;
                        color: rgb(17, 17, 17);
                    }
                    
                    .iSpIQi {
                        font-size: 7px;
                        line-height: 6px;
                        margin-top: 0;
                        color: rgb(17, 17, 17);
                    }
                    
                    .cqCDVm {
                        text-align: right;
                        margin-top: 4px;
                        font-size: 6px;
                        line-height: 16px;
                        color: 
                        rgba(17, 17, 17, 0.5);
                        margin-right: -8px;
                        margin-bottom: -4px;
                    }
              </style>
              
              ${finalpopupmodelchat}
              <a href='${!iconModelPopup ? link :"javascript:void(0);"}' target=_blank class="squadkin-whatsapp-button" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="${size}" height="${size}" class="squadkin-whatsapp-button-logo">
									<circle cx="256" cy="256" r="256" fill=${bgcolors} />
									<path d="M256 108c-88.37 0-160 64.47-160 144 0 46.46 24.64 87.79 63.31 114.73-3.15 22.18-12.78 46.22-38.64 63.78 24.59-1.28 72.96-10.45 101.44-42.34 11.08 2.37 22.56 3.83 33.89 3.83 88.37 0 160-64.47 160-144S344.37 108 256 108z" fill=${colors} />
									<circle cx="192" cy="252" r="20" fill=${bgcolors} />
									<circle cx="256" cy="252" r="20" fill=${bgcolors} />
									<circle cx="320" cy="252" r="20" fill=${bgcolors} />
                </svg>
              </a>`;
              break;
            case "option3":
              button.innerHTML = `
              <style>
                .squadkin-whatsapp-button {
                  border-radius: 100%;
                  text-decoration: none;
                  width: ${sizes[size]};
                  height: ${sizes[size]};
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  animation-name: waAnimation;
                  animation-duration: 1s;
                  animation-timing-function: ease-out;
                  animation-iteration-count: infinite;
                }
                .squadkin-whatsapp-button:focus,
                .squadkin-whatsapp-button:active,
                .squadkin-whatsapp-button:hover{
                    background-color: transparent;
                }
    
                .squadkin-whatsapp-button-agent-image {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 50%;
                }
    
                .squadkin-whatsapp-button-logo {
                  width: 10px;
                  height: 10px;
                  padding: 5px;
                  position: absolute;
                  bottom: 0;
                  right: 0;
                  background-color: ${bgcolors};
                  border-radius: 100%;
                }
                @keyframes waAnimation {
                  0% {
                    box-shadow: 0 0 0 0 rgba(74, 175, 80, 0.5);
                  }
                  80% {
                    box-shadow: 0 0 0 14px rgba(74, 175, 80, 0);
                  }
                }
              </style>
              <style>
                    #whatsapp-chat {
                        box-sizing: border-box !important;
                        outline: none !important;
                        position: fixed;
                        width: 200px;
                        border-radius: 10px;
                        box-shadow: 0 1px 15px rgba(32, 33, 36, 0.28);
                        bottom: 50px;
                        right: 10px;
                        overflow: hidden;
                        z-index: 99;
                        animation-name: showchat;
                        animation-duration: .1s;
                        transform: scale(1);
                    }

                    .whatsapp-chat-header.sk-time-blank {
                        padding: 5px 5px 15px;
                    }
                    
                    .whatsapp-chat-header {
                        background: #009688;
                        background: #095e54;
                        color: #fff;
                        padding: 5px;
                        
                        & h3 {
                        margin: 0 0 10px;
                        }
                        
                        & p {
                        font-size: 7px !important;
                        line-height: 1.7;
                        margin: 0;
                        }
                        
                        .whatsapp-chat-name {
                        font-size: 8px;
                        font-weight: 600;
                        padding-bottom: 0;
                        margin-bottom: 0;
                        line-height: 0.5;
                        }
                    }
                    
                    .whatsapp-chat-avatar {
                        position: relative;
                        display: block;
                    }
                    .whatsapp-chat-avatar::after {
                        content: "";
                        bottom: 0px;
                        right: 0px;
                        width: 8px;
                        height: 8px;
                        box-sizing: border-box;
                        background-color: #4ad504;
                        display: block;
                        position: relative;
                        z-index: 1;
                        border-radius: 50%;
                        border: 2px solid #095e54;
                        left: 18px;
                        top: 22px;
                    }
                        
                    .whatsapp-chat-avatar img {
                        border-radius: 100%;
                        width: 30px;
                        float: left;
                        margin: 0 5px 0 0;
                        height: 30px;
                        object-fit: contain;
                    }

                    .info-chat span {
                        display: block;
                    }
                    #get-label,
                    span.chat-label {
                        font-size: 12px;
                        color: #888;
                    }
                    #get-nama,
                    span.chat-nama {
                        margin: 5px 0 0;
                        font-size: 15px;
                        font-weight: 700;
                        color: #222;
                    }
                    #get-label,
                    #get-nama {
                        color: #fff;
                    }
                    span.my-number {
                        display: none;
                    }
                    /* .blanter-msg {
                        color: #444;
                        padding: 20px;
                        font-size: 12.5px;
                        text-align: center;
                        border-top: 1px solid #ddd;
                    } */
                    textarea#chat-input {
                        border: none;
                        font-family: "Arial", sans-serif;
                        width: 100%;
                        height: 10px;
                        outline: none;
                        resize: none;
                        padding: 8px;
                        font-size: 8px;
                    }
                    
                    a#send-it {
                        width: 30px;
                        font-weight: 700;
                        padding: 0px 0px 0px 12px;
                        background: #eee;
                        border-radius: 0px;
                        height: 26px;
                        
                        svg {
                        fill:#a6a6a6;
                        height: 12px;
                        width: 12px;
                        }
                    }
                    
                    .first-msg {
                        background: transparent;
                        padding: 30px;
                        text-align: center;
                        & span {
                        background: #e2e2e2;
                        color: #333;
                        font-size: 14.2px;
                        line-height: 1.7;
                        border-radius: 10px;
                        padding: 15px 20px;
                        display: inline-block;
                        }
                    }
                    
                    .start-chat .blanter-msg {
                        display: flex;
                    }
                    #get-number {
                        display: none;
                    }
                    a.close-chat.sk-time-blank {
                        top: 3px;
                    }
                    a.close-chat {
                        position: absolute;
                        top: 5px;
                        right: 10px;
                        color: #fff;
                        font-size: 20px;
                        text-decoration: none;
                    }
                    
                    @keyframes ZpjSY{
                        0% {
                        background-color: rgb(182, 181, 186);
                        }
                        15% {
                        background-color: rgb(17, 17, 17);
                        }
                        25% {
                        background-color: rgb(182, 181, 186);
                        }
                    }
                    
                    @keyframes hPhMsj {
                        15% {
                        background-color: rgb(182, 181, 186);
                        }
                        25% {
                        background-color: rgb(17, 17, 17);
                        }
                        35% {
                        background-color: rgb(182, 181, 186);
                        }
                    }
                    
                    @keyframes iUMejp {
                        25% {
                        background-color: rgb(182, 181, 186);
                        }
                        35% {
                        background-color: rgb(17, 17, 17);
                        }
                        45% {
                        background-color: rgb(182, 181, 186);
                        }
                    }
                    
                    
                    @keyframes showhide {
                        from {
                        transform: scale(0.5);
                        opacity: 0;
                        }
                    }
                    @keyframes showchat {
                        from {
                        transform: scale(0);
                        opacity: 0;
                        }
                    }
                    @media screen and (max-width: 372px) {
                        #whatsapp-chat {
                        width: 15rem;
                        font-size: 80%;
                        }
                    }
                    .hide {
                        display: none;
                        animation-name: showhide;
                        animation-duration: 0.5s;
                        transform: scale(1);
                        opacity: 1;
                    }
                    .show {
                        display: block;
                        animation-name: showhide;
                        animation-duration: 0.5s;
                        transform: scale(1);
                        opacity: 1;
                    }
                    
                    .whatsapp-message-container {
                        display: flex;
                        z-index: 1;
                    }
                    
                    .whatsapp-message {
                        padding: 7px 14px 6px;
                        background-color: rgb(255, 255, 255);
                        border-radius: 0px 8px 8px;
                        position: relative;
                        transition: all 0.3s ease 0s;
                        opacity: 0;
                        transform-origin: center top 0px;
                        z-index: 2;
                        box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
                        margin-top: 4px;
                        margin-left: -54px;
                        max-width: calc(100% - 66px);
                    }
                    
                    .whatsapp-chat-body {
                        padding: 20px 20px 20px 10px;
                        background-color: rgb(230, 221, 212);
                        position: relative;
                        &::before {
                        display: block;
                        position: absolute;
                        content: "";
                        left: 0px;
                        top: 0px;
                        height: 100%;
                        width: 100%;
                        z-index: 0;
                        opacity: 0.08;
                        background-image: url("https://elfsight.com/assets/chats/patterns/whatsapp.png");
                        // background-image: url(https://res.cloudinary.com/eventbree/image/upload/v1575782560/Widgets/whatsappbg_opt.jpg);
                        }
                    }
                    
                    .dAbFpq {
                        display: flex;
                        z-index: 1;
                    }
                    
                    .eJJEeC {
                        background-color: rgb(255, 255, 255);
                        width: 52.5px;
                        height: 32px;
                        border-radius: 16px;
                        display: flex;
                        -moz-box-pack: center;
                        justify-content: center;
                        -moz-box-align: center;
                        align-items: center;
                        margin-left: 10px;
                        opacity: 0;
                        transition: all 0.1s ease 0s;
                        z-index: 1;
                        box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
                    }
                    
                    .hFENyl {
                        position: relative;
                        display: flex;
                    }
                    
                    .ixsrax {
                        height: 5px;
                        width: 5px;
                        margin: 0px 2px;
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;
                        animation-duration: 1.2s;
                        animation-iteration-count: infinite;
                        animation-timing-function: linear;
                        top: 0px;
                        background-color: rgb(158, 157, 162);
                        animation-name: ZpjSY;
                    }
                    
                    .dRvxoz {
                    
                        height: 5px;
                        width: 5px;
                        margin: 0px 2px;
                        background-color: rgb(182, 181, 186);
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;
                        animation-duration: 1.2s;
                        animation-iteration-count: infinite;
                        animation-timing-function: linear;
                        top: 0px;
                        animation-name: hPhMsj;
                    }
                    
                    .kAZgZq {
                            padding: 2px 10px 2px;
                            background-color: rgb(255, 255, 255);
                            border-radius: 0px 8px 8px;
                            position: relative;
                            transition: all 0.3s ease 0s;
                            opacity: 0;
                            transform-origin: center top 0px;
                            z-index: 2;
                            box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
                            margin-top: 4px;
                            margin-left: -61px;
                            max-width: calc(100%);
                        &::before {
                        position: absolute;
                        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAmCAMAAADp2asXAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACQUExURUxpccPDw9ra2m9vbwAAAAAAADExMf///wAAABoaGk9PT7q6uqurqwsLCycnJz4+PtDQ0JycnIyMjPf3915eXvz8/E9PT/39/RMTE4CAgAAAAJqamv////////r6+u/v7yUlJeXl5f///5ycnOXl5XNzc/Hx8f///xUVFf///+zs7P///+bm5gAAAM7Ozv///2fVensAAAAvdFJOUwCow1cBCCnqAhNAnY0WIDW2f2/hSeo99g1lBYT87vDXG8/6d8oL4sgM5szrkgl660OiZwAAAHRJREFUKM/ty7cSggAABNFVUQFzwizmjPz/39k4YuFWtm55bw7eHR6ny63+alnswT3/rIDzUSC7CrAziPYCJCsB+gbVkgDtVIDh+DsE9OTBpCtAbSBAZSEQNgWIygJ0RgJMDWYNAdYbAeKtAHODlkHIv997AkLqIVOXVU84AAAAAElFTkSuQmCC");
                        background-position: 50% 50%;
                        background-repeat: no-repeat;
                        background-size: contain;
                        content: "";
                        top: 0px;
                        left: -12px;
                        width: 12px;
                        height: 19px;
                    }
                    }
                    
                    .bMIBDo {
                        font-size: 7px;
                        font-weight: 700;
                        line-height: 18px;
                        color: rgba(0, 0, 0, 0.4);
                    }
                    
                    .iSpIQi {
                        font-size: 8px;
                        line-height: 19px;
                        margin-top: 4px;
                        color: rgb(17, 17, 17);
                    }
                    
                    .iSpIQi {
                        font-size: 7px;
                        line-height: 6px;
                        margin-top: 0;
                        color: rgb(17, 17, 17);
                    }
                    
                    .cqCDVm {
                        text-align: right;
                        margin-top: 4px;
                        font-size: 6px;
                        line-height: 16px;
                        color: 
                        rgba(17, 17, 17, 0.5);
                        margin-right: -8px;
                        margin-bottom: -4px;
                    }
              </style>
              ${finalpopupmodelchat}
              <a href='${!iconModelPopup ? link :"javascript:void(0);"}' target=_blank class="squadkin-whatsapp-button">
                <img class="squadkin-whatsapp-button-agent-image" src="${agentImage}"/>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="${size}" height="${size}" class="squadkin-whatsapp-button-logo">
									<circle cx="256" cy="256" r="256" fill=${bgcolors} />
									<path d="M256 108c-88.37 0-160 64.47-160 144 0 46.46 24.64 87.79 63.31 114.73-3.15 22.18-12.78 46.22-38.64 63.78 24.59-1.28 72.96-10.45 101.44-42.34 11.08 2.37 22.56 3.83 33.89 3.83 88.37 0 160-64.47 160-144S344.37 108 256 108z" fill=${colors} />
									<circle cx="192" cy="252" r="20" fill=${bgcolors} />
									<circle cx="256" cy="252" r="20" fill=${bgcolors} />
									<circle cx="320" cy="252" r="20" fill=${bgcolors} />
                </svg>
              </a>`;
    
              break;
          }
    
          return button;
        }
  
        getVisibilityStyle(showOn) {
            const style = document.createElement("style");
            let styleContent = "";
            if (showOn.includes("mobile") == false) {
                styleContent += `
                @media (max-width: 767px) {
                .squadkin-wrapper-container {
                    display: none;
                }
                }`
            }
  
            if (showOn.includes("desktop") == false) {
                styleContent += `
                @media (min-width: 768px) {
                .squadkin-wrapper-container {
                    display: none;
                }
                }`
            }
  
            style.textContent = styleContent;
  
            return style;
        }
  
        getPlacementStyle(position, disancefromtop, disancefromleft, disancefromright, disancefrombottom) {
            const style = document.createElement("style");
            let styleContent = `
            .squadkin-wrapper-container {`
  
            switch (position) {
                case "left_bottom":
                    styleContent += `left: ${disancefromleft}px;
                                     bottom: ${disancefrombottom}px;`
                    break;
                case "right_bottom":
                    styleContent += `right: ${disancefromright}px;
                                     bottom: ${disancefrombottom}px;`
                    break;
                case "left_middle":
                    styleContent += `left: ${disancefromleft}px;
                                     top:${disancefromtop}%;`
                    break;
                case "right_middle":
                    styleContent += `right: ${disancefromright}px;
                                    top:${disancefromtop}%;`
                    break;
            }
  
            styleContent += `}`
  
            style.textContent = styleContent;
            
            return style;
        }
  
        getSizeStyle(size, position) {
          const style = document.createElement("style");
    
          const sizes = {
            "small": 1,
            "medium": 1.30,
            "large": 1.80
          };
    
          let styleContent = `
          .squadkin-wrapper-container {
            transform: scale(${sizes[size]});`;
    
          switch (position) {
            case "left_bottom":
              styleContent += `transform-origin: left bottom;`;
              break;
            case "right_bottom":
              styleContent += `transform-origin: right bottom;`;
              break;
            case "left_middle":
            styleContent += `transform-origin: left bottom;`;
            break;
            case "right_middle":
            styleContent += `transform-origin: right bottom;`;
            break;
          }
    
          styleContent += `}`;
    
          style.textContent = styleContent;
    
          return style;
        }
  
        getCustomCSSStyle(customCSS) {
            const style = document.createElement("style");
  
            if (!customCSS) {
                return style;
            }
  
            style.textContent = customCSS;
  
            return style;
        }
  
        getWhatsAppUrl(phoneNumber, message) {
            if (!phoneNumber) {
                throw ('phoneNumber missing')
            }
  
            let url = new URL("https://api.whatsapp.com/send/");
            url.searchParams.append("phone", phoneNumber);
  
            if (message) {
                message = this.applyVariables(message);
                url.searchParams.append("text", message);
            }
            return url;
        }
    }
  
    window.customElements.define('whatsapp-chat-by-squadkin', WhatsAppChatBySquadkin);
  
    document.body.appendChild(new WhatsAppChatBySquadkin);
  }());